import { Injectable } from '@angular/core';
import { Url } from '../models/url/url.model';
import { UrlParam } from '../models/url/url-param.model';
import { UrlParams } from '../models/url/url-params.model';
import { SessionService } from './session.service';

@Injectable()
export class RedirectService {

    public static get WILL_SCHEDULE():string {
        return 'will-schedule';
    }
    public static get WILL_RESCHEDULE():string {
        return 'will-reschedule';
    }
    public static get RESCHEDULED():string {
        return 'rescheduled';
    }
    public static get SCHEDULED():string {
        return 'scheduled';
    }
    public static get ABORTED():string {
        return 'aborted';
    }
    public static get ERROR():string {
        return 'error';
    }
    public static get CANCELLED():string {
        return 'cancelled';
    }
    public static get SESSION(): string {
        return 'session';
    }

    constructor(private session: SessionService) {}

    public getReturnUrl(status:string):Url {

        let url:Url;
        let params:UrlParams = new UrlParams();

        if(!this.session.returnUrl){
            return new Url('/', null, true);
        } 

        params.add(new UrlParam("status", status));

        if(this.session.reason){ 
            params.add(new UrlParam("reason", this.session.reason)); 
        }
        if(this.session.user.id){ 
            params.add(new UrlParam("zone", this.session.user.id)); 
        }
        if(this.session.token){ 
            params.add(new UrlParam("token", this.session.token)); 
        }
        if(this.session.appointment && this.session.appointment.applicationCode){ 
            params.add(new UrlParam("appCode", this.session.appointment.applicationCode)); 
        }
        if(this.session.appointment && this.session.appointment.id > 0){
            params.add(new UrlParam("appointmentId", this.session.appointment.id));
        }
        if(this.session.appointmentSlot && this.session.appointmentSlot.startTimestamp && this.session.finalizeAppointmentExternally){
            params.add(new UrlParam("appointmentStartTimestamp", this.session.appointmentSlot.startTimestamp));
        }
        if(this.session.appointmentSlot && this.session.appointmentSlot.endTimestamp && this.session.finalizeAppointmentExternally){
            params.add(new UrlParam("appointmentEndTimestamp", this.session.appointmentSlot.endTimestamp));
        }
        if(this.session.location && this.session.location.id){
            params.add(new UrlParam('locationId', this.session.location.id));
        }
        if (this.session.location && this.session.location.name) {
            params.add(new UrlParam('locationName', this.session.location.name));
        }
        if (this.session.location && this.session.location.tzData) {
            params.add(new UrlParam('tzData', this.session.location.tzData));
        }

        let returnUrlBase:string = decodeURIComponent(this.session.returnUrl);

        url = new Url(returnUrlBase, params, true); 
        return url;

    }

}